import {Preloader, UriHelper} from 'neo-common';
import {IClientHub} from '../IClientHub';
import {IClientEvents} from '../IClientEvents';
import {Logger} from "neo-common";
import {Platforms} from '../../../Platforms';
import {IPlugin} from '../IPlugin';
import {AutoplayData, BetData, GameDataLoaded, SpinReceived} from '../../../Platforms/IPlatforms';

export class BasePlugin {

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static AsyncTasks: Array<() => Promise<void>> = [];

    public static AsyncRunning: boolean = false;

    protected _configuration: any;

    protected _instanceName: string;

    protected _pluginUrl: string;

    protected _clientHub: IClientHub;

    protected _clientEvents: IClientEvents;

    protected _callbacks: Object;

    protected _startData: GameDataLoaded

    protected _idle: boolean;

    protected _started: boolean;

    protected _callStart: boolean;

    protected _hasWin: boolean;

    protected _callbackCall: boolean;

    protected _inFeature: boolean;

    protected _stopped: boolean;

    protected _freezed: boolean;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(instanceName: string, pluinUrl: string, clientHub: IClientHub, gameConfiguration: any) {
        this._configuration = gameConfiguration;
        this._instanceName = instanceName;
        this._pluginUrl = pluinUrl;
        this._clientHub = clientHub;
        this._callbacks = {};
        this._clientEvents = this.getGameClientEvents();
        this._idle = false;
        this._started = false;
        this._callStart = false;
        this._hasWin = false;
        this._callbackCall = false;
        this._inFeature = false;
        this._stopped = false;
        this._freezed = false;
    }

    //******************************************************************************************************************
    //  CLIENT EVENTS
    //******************************************************************************************************************

    protected getGameClientEvents(): IClientEvents {
        const _self = this;
        return {
            on: {
                error: _self._error.bind(_self),
                gameStarted: _self._gameStarted.bind(_self),
                roundInit: _self._roundInit.bind(_self),
                roundStarted: _self._roundStarted.bind(_self),
                spinStarted: _self._spinStarted.bind(_self),
                spinEnded: _self._spinEnded.bind(_self),
                roundEnded: _self._roundEnded.bind(_self),
                featureStarted: _self._featureStarted.bind(_self),
                featureInit: _self._featureInit.bind(_self),
                featureFinished: _self._featureFinished.bind(_self),
                autoplayStarted: _self._autoplayStarted.bind(_self),
                autoplayFinished: _self._autoplayFinished.bind(_self),
                gotoHelp: _self._gotoHelp.bind(_self),
                gotoPaytable: _self._gotoPaytable.bind(_self),
                gotoSettings: _self._gotoSettings.bind(_self),
                setVolume: _self._setVolume.bind(_self),
                betChanged: _self._betChanged.bind(_self),
                closeMenu: _self._closeMenu.bind(_self),
                dialogOpened: _self._dialogOpened.bind(_self),
                gamePlayStop: _self._gamePlayStop.bind(_self),
                gamePlayResume: _self._gamePlayResume.bind(_self),
                gamePlayFreeze: _self._gamePlayFreeze.bind(_self),
                gamePlayUnfreeze: _self._gamePlayUnfreeze.bind(_self),
                webSocketsInitialized: _self._webSocketsInitialized.bind(_self),
                iconsCountAvailable: _self._iconsCountAvailable.bind(_self)
            },
            send: {
                stopAutoplay: () => {
                    _self.log(`P2G - stopAutoplay`);
                    Platforms.stopAutoplay();
                },
                gamePlaySupressSpinOnCollect: () => {
                    //prevent stop autoplay in feature
                    if (this._inFeature) {
                        return;
                    }

                    if (!_self._idle) {
                        if (this._hasWin) {
                            //to prevent game stuck, this can be called only when game in not in idle
                            _self.log(`P2G - gamePlaySupressSpinOnCollect`);
                            Platforms.gamePlaySupressSpinOnCollect();
                        } else {
                            //if there is no win, just stop autoplay (even if there is no autoplay enabled)
                            _self.log(`P2G - stopAutoplay`);
                            Platforms.stopAutoplay();
                        }
                    }
                },
                restoreAutoplay: () => {
                    _self.log(`P2G - restoreAutoplay`);
                    Platforms.restoreAutoplay();
                },
                resizeGame: () => {
                    _self.log(`P2G - resizeGame`);
                    Platforms.resizeGame();
                },
                refreshBalance: () => {
                    _self.log(`P2G - refreshBalance`);
                    Platforms.refreshBalance();
                },
                gamePlayStop: () => {
                    if (this._stopped) {
                        return;
                    }

                    if (this._idle) {
                        _self._stopped = true;
                    }

                    _self.log(`P2G - gamePlayStop`);
                    _self._callbackCall = true;
                    Platforms.gamePlayStop(true);
                },
                gamePlayResume: () => {
                    if (!this._stopped) {
                        return;
                    }

                    _self.log(`P2G - gamePlayResume`);
                    _self._stopped = false;
                    _self._callbackCall = true;
                    Platforms.gamePlayResume();
                },
                gamePlayFreeze: () => {
                    if (this._freezed) {
                        return;
                    }

                    _self.log(`P2G - gamePlayFreeze`);
                    _self._freezed = true;
                    _self._callbackCall = true;
                    Platforms.gamePlayFreeze();
                },
                gamePlayUnfreeze: () => {
                    if (!this._freezed) {
                        return;
                    }

                    _self.log(`P2G - gamePlayUnfreeze`);
                    _self._freezed = false;
                    _self._callbackCall = true;
                    Platforms.gamePlayUnfreeze();
                },
                gameAudioEnable: () => {
                    _self.log(`P2G - gameAudioEnable`);
                    Platforms.gameAudioEnable();
                },
                gameAudioMute: () => {
                    _self.log(`P2G - gameAudioMute`);
                    Platforms.gameAudioMute();
                },
                showHelp: () => {
                    _self.log(`P2G - showHelp`);
                    Platforms.showHelp();
                },
                hideHelp: () => {
                    _self.log(`P2G - hideHelp`);
                    Platforms.hideHelp();
                },
                toggleHelp: () => {
                    _self.log(`P2G - toggleHelp`);
                    Platforms.toggleHelp();
                },
                showPaytable: () => {
                    _self.log(`P2G - showPaytable`);
                    Platforms.showPaytable();
                },
                hidePaytable: () => {
                    _self.log(`P2G - hidePaytable`);
                    Platforms.hidePaytable();
                },
                togglePaytable: () => {
                    _self.log(`P2G - togglePaytable`);
                    Platforms.togglePaytable();
                },
                closeMenu: () => {
                    _self.log(`P2G - closeMenu`);
                    _self._callbackCall = true;
                    Platforms.closeMenu();
                },
                updateUI: () => {
                    _self.log(`P2G - updateUI`);
                    Platforms.updateUI()
                },
                asyncTask: _self.asyncTask
            },
            get: {
                getTimeData: () => {return Platforms.getTimeData()},
                getGameTime: (utcTime: string) => {return Platforms.getGameTime(utcTime)}
            }
        }
    }

    public error(code: string, message: string): void {
        if (this._callbacks['error'] != null) {
            this.log(`G2P - Error - ${code} - ${message}`);
            const fn = this._callbacks['error'];
            fn(code, message);
        } else if (!this._started) {
            this._callbacks['_error'] = {code: code, message: message};
        }
    }

    protected _error(fnc: (code: string, message: string) => void): void {
        this._callbacks['error'] = fnc;

        if (this._callbacks['_error'] != null) {
            this.log(`G2P - Error - ${this._callbacks['_error']['code']} - ${this._callbacks['_error']['message']}`);
            fnc(this._callbacks['_error']['code'], this._callbacks['_error']['message']);
            this._callbacks['_error'] = null;
        }
    }

    public gameStarted(data: GameDataLoaded): void {
        this._callStart = true;
        this._startData = data;

        if (this._callbacks['gameStarted'] != null && !this._started) {
            this.log(`G2P - gameStarted - ${JSON.stringify(data)}`);
            const fn = this._callbacks['gameStarted'];
            fn(data);
            this._started = true;
            this._callStart = false;
        }
    }

    protected _gameStarted(fnc: (data: GameDataLoaded) => void): void {
        this._callbacks['gameStarted'] = fnc;
    }

    public roundInit(): Promise<void> {
        this._idle = true;

        if (this._callbacks['roundInit'] != null) {
            this.log(`G2P - roundInit`);
            const fn = this._callbacks['roundInit'];
            return fn();
        }

        return Promise.resolve();
    }

    protected _roundInit(fnc: () => Promise<void>): void {
        this._callbacks['roundInit'] = fnc;
    }

    public roundStarted(): void {
        this._idle = false;

        if (this._callbacks['roundStarted'] != null) {
            this.log(`G2P - roundStarted`);
            const fn = this._callbacks['roundStarted'];
            fn();
        } else if (!this._started) {
            this._callbacks['_roundStarted'] = true;
        }
    }

    protected _roundStarted(fnc: () => void): void {
        this._callbacks['roundStarted'] = fnc;

        if (this._callbacks['_roundStarted'] != null) {
            this.log(`G2P - roundStarted`);
            fnc();
            this._callbacks['_roundStarted'] = null;
        }
    }

    public spinStarted(): void {
        this._hasWin = false;

        if (this._callbacks['spinStarted'] != null) {
            this.log(`G2P - spinStarted`);
            const fn = this._callbacks['spinStarted'];
            fn();
        } else if (!this._started) {
            this._callbacks['_spinStarted'] = true;
        }
    }

    protected _spinStarted(fnc: () => void): void {
        this._callbacks['spinStarted'] = fnc;

        if (this._callbacks['_spinStarted'] != null) {
            this.log(`G2P - spinStarted`);
            fnc();
            this._callbacks['_spinStarted'] = null;
        }
    }

    public spinReceived(args?: SpinReceived): void {
        if (args != null) {
            this._hasWin = args.win > 0;
        }
    }

    public spinEnded(): void {
        if (this._callbacks['spinEnded'] != null) {
            this.log(`G2P - spinEnded`);
            const fn = this._callbacks['spinEnded'];
            fn();
        } else if (!this._started) {
            this._callbacks['_spinEnded'] = true;
        }
    }

    protected _spinEnded(fnc: () => void): void {
        this._callbacks['spinEnded'] = fnc;

        if (this._callbacks['_spinEnded'] != null) {
            this.log(`G2P - spinEnded`);
            fnc();
            this._callbacks['_spinEnded'] = null;
        }
    }

    public roundEnded(): void {
        if (this._callbacks['roundEnded'] != null) {
            this.log(`G2P - roundEnded`);
            const fn = this._callbacks['roundEnded'];
            fn();
        } else if (!this._started) {
            this._callbacks['_roundEnded'] = true;
        }
    }

    protected _roundEnded(fnc: () => void): void {
        this._callbacks['roundEnded'] = fnc;

        if (this._callbacks['_roundEnded'] != null) {
            this.log(`G2P - roundEnded`);
            fnc();
            this._callbacks['_roundEnded'] = null;
        }
    }

    public featureStarted(): void {
        this._inFeature = true;

        if (this._callbacks['featureStarted'] != null) {
            this.log(`G2P - featureStarted`);
            const fn = this._callbacks['featureStarted'];
            fn();
        } else if (!this._started) {
            this._callbacks['_featureStarted'] = true;
        }
    }

    protected _featureStarted(fnc: () => void): void {
        this._callbacks['featureStarted'] = fnc;

        if (this._callbacks['_featureStarted'] != null) {
            this.log(`G2P - featureStarted`);
            fnc();
            this._callbacks['_featureStarted'] = null;
        }
    }

    public featureInit(): void {
        this._inFeature = true;

        if (this._callbacks['featureInit'] != null) {
            this.log(`G2P - featureInit`);
            const fn = this._callbacks['featureInit'];
            fn();
        } else if (!this._started) {
            this._callbacks['_featureInit'] = true;
        }
    }

    protected _featureInit(fnc: () => void): void {
        this._callbacks['featureInit'] = fnc;

        if (this._callbacks['_featureInit'] != null) {
            this.log(`G2P - featureInit`);
            fnc();
            this._callbacks['_featureInit'] = null;
        }
    }

    public featureFinished(): void {
        this._inFeature = false;

        if (this._callbacks['featureFinished'] != null) {
            this.log(`G2P - featureFinished`);
            const fn = this._callbacks['featureFinished'];
            fn();
        } else if (!this._started) {
            this._callbacks['_featureFinished'] = true;
        }
    }

    protected _featureFinished(fnc: () => void): void {
        this._callbacks['featureFinished'] = fnc;

        if (this._callbacks['_featureFinished'] != null) {
            this.log(`G2P - featureFinished`);
            fnc();
            this._callbacks['_featureFinished'] = null;
        }
    }

    public autoplayStarted(): void {
        if (this._callbacks['autoplayStarted'] != null) {
            this.log(`G2P - autoplayStarted`);
            const fn = this._callbacks['autoplayStarted'];
            fn();
        } else if (!this._started) {
            this._callbacks['_autoplayStarted'] = true;
        }
    }

    protected _autoplayStarted(fnc: () => void): void {
        this._callbacks['autoplayStarted'] = fnc;

        if (this._callbacks['_autoplayStarted'] != null) {
            this.log(`G2P - autoplayStarted`);
            fnc();
            this._callbacks['_autoplayStarted'] = null;
        }
    }

    public autoplayFinished(args?: AutoplayData): void {
        if (this._callbacks['autoplayFinished'] != null) {
            this.log(`G2P - autoplayFinished - ${args ? JSON.stringify(args) : 'none'}`);
            const fn = this._callbacks['autoplayFinished'];
            fn(args);
        } else if (!this._started) {
            this._callbacks['_autoplayFinished'] = true;
        }
    }

    protected _autoplayFinished(fnc: (args?: AutoplayData) => void): void {
        this._callbacks['autoplayFinished'] = fnc;

        if (this._callbacks['_autoplayFinished'] != null) {
            this.log(`G2P - autoplayFinished`);
            fnc();
            this._callbacks['_autoplayFinished'] = null;
        }
    }

    public gotoHelp(): void {
        if (this._callbacks['gotoHelp'] != null) {
            this.log(`G2P - gotoHelp`);
            const fn = this._callbacks['gotoHelp'];
            fn();
        }
    }

    protected _gotoHelp(fnc: () => void): void {
        this._callbacks['gotoHelp'] = fnc;
    }

    public gotoPaytable(): void {
        if (this._callbacks['gotoPaytable'] != null) {
            this.log(`G2P - gotoPaytable`);
            const fn = this._callbacks['gotoPaytable'];
            fn();
        }
    }

    protected _gotoPaytable(fnc: () => void): void {
        this._callbacks['gotoPaytable'] = fnc;
    }

    public gotoSettings(): void {
        if (this._callbacks['gotoSettings'] != null) {
            this.log(`G2P - gotoSettings`);
            const fn = this._callbacks['gotoSettings'];
            fn();
        }
    }

    protected _gotoSettings(fnc: () => void): void {
        this._callbacks['gotoSettings'] = fnc;
    }

    public setVolume(level: number): void {
        if (this._callbacks['setVolume'] != null) {
            this.log(`G2P - setVolume - ${level}`);
            const fn = this._callbacks['setVolume'];
            fn(level);
        } else if (!this._started) {
            this._callbacks['_setVolume'] = {level: level};
        }
    }

    protected _setVolume(fnc: (level: number) => void): void {
        this._callbacks['setVolume'] = fnc;

        if (this._callbacks['_setVolume'] != null) {
            this.log(`G2P - setVolume - ${this._callbacks['_setVolume']['level']}`);
            fnc(this._callbacks['_setVolume']['level']);
            this._callbacks['_setVolume'] = null;
        }
    }

    public betChanged(bet: BetData): void {
        if (this._callbacks['bet'] != null) {
            this.log(`G2P - betChanged - ${bet ? JSON.stringify(bet) : 'none'}`);
            const fn = this._callbacks['bet'];
            fn(bet);
        }
    }

    protected _betChanged(fnc: () => void): void {
        this._callbacks['bet'] = fnc;
    }

    public dialogOpened(type: string, isOpen: boolean): void {
        this._idle = !isOpen;

        if (this._callbacks['dialogOpened'] != null) {
            this.log(`G2P - dialogOpened - ${type} - ${isOpen}`);
            const fn = this._callbacks['dialogOpened'];
            fn(type, isOpen);
        } else if (!this._started) {
            this._callbacks['_dialogOpened'] = {type: type, isOpen: isOpen};
        }
    }

    protected _dialogOpened(fnc: (type: string, isOpen: boolean) => void): void {
        this._callbacks['dialogOpened'] = fnc;

        if (this._callbacks['_dialogOpened'] != null) {
            this.log(`G2P - dialogOpened - ${this._callbacks['_dialogOpened']['type']} - ${this._callbacks['_dialogOpened']['isOpen']}`);
            fnc(this._callbacks['_dialogOpened']['type'], this._callbacks['_dialogOpened']['isOpen']);
            this._callbacks['_dialogOpened'] = null;
        }
    }

    protected _closeMenu(fnc: () => void): void {
        this._callbacks['closeMenu'] = fnc;
    }

    public closeMenu(): void {
        if (this._callbackCall) {
            this._callbackCall = false;
            return;
        }

        if (this._callbacks['closeMenu'] != null) {
            this.log(`G2P - closeMenu`);
            const fn = this._callbacks['closeMenu'];
            fn();
        }
    }

    protected _gamePlayStop(fnc: () => void): void {
        this._callbacks['gamePlayStop'] = fnc;

        if (this._callbacks['_gamePlayStop'] != null) {
            this.log(`G2P - gamePlayStop`);
            fnc();
            this._callbacks['_gamePlayStop'] = null;
        }
    }

    public gamePlayStop(): void {
        if (this._callbackCall) {
            this._callbackCall = false;
            return;
        }

        if (this._callbacks['gamePlayStop'] != null) {
            this.log(`G2P - gamePlayStop`);
            const fn = this._callbacks['gamePlayStop'];
            fn();
        } else if (!this._started) {
            this._callbacks['_gamePlayStop'] = true;
        }
    }

    protected _gamePlayResume(fnc: () => void): void {
        this._callbacks['gamePlayResume'] = fnc;

        if (this._callbacks['_gamePlayResume'] != null) {
            this.log(`G2P - gamePlayResume`);
            fnc();
            this._callbacks['_gamePlayResume'] = null;
        }
    }

    public gamePlayResume(): void {
        if (this._callbackCall) {
            this._callbackCall = false;
            return;
        }

        if (this._callbacks['gamePlayResume'] != null) {
            this.log(`G2P - gamePlayResume`);
            const fn = this._callbacks['gamePlayResume'];
            fn();
        } else if (!this._started) {
            this._callbacks['_gamePlayResume'] = true;
        }
    }

    protected _gamePlayFreeze(fnc: () => void): void {
        this._callbacks['gamePlayFreeze'] = fnc;

        if (this._callbacks['_gamePlayFreeze'] != null) {
            this.log(`G2P - gamePlayFreeze`);
            fnc();
            this._callbacks['_gamePlayFreeze'] = null;
        }
    }

    public gamePlayFreeze(): void {
        if (this._callbackCall) {
            this._callbackCall = false;
            return;
        }

        if (this._callbacks['gamePlayFreeze'] != null) {
            this.log(`G2P - gamePlayFreeze`);
            const fn = this._callbacks['gamePlayFreeze'];
            fn();
        } else if (!this._started) {
            this._callbacks['_gamePlayFreeze'] = true;
        }
    }

    protected _gamePlayUnfreeze(fnc: () => void): void {
        this._callbacks['gamePlayUnfreeze'] = fnc;

        if (this._callbacks['_gamePlayUnfreeze'] != null) {
            this.log(`G2P - gamePlayUnfreeze`);
            fnc();
            this._callbacks['_gamePlayUnfreeze'] = null;
        }
    }

    public gamePlayUnfreeze(): void {
        if (this._callbackCall) {
            this._callbackCall = false;
            return;
        }

        if (this._callbacks['gamePlayUnfreeze'] != null) {
            this.log(`G2P - gamePlayUnfreeze`);
            const fn = this._callbacks['gamePlayUnfreeze'];
            fn();
        } else if (!this._started) {
            this._callbacks['_gamePlayUnfreeze'] = true;
        }
    }

    public webSocketsInitialized(): void {
        if (this._callbacks['webSocketsInitialized'] != null) {
            this.log(`G2P - webSocketsInitialized`);
            const fn = this._callbacks['webSocketsInitialized'];
            fn();
        } else if (!this._started) {
            this._callbacks['_webSocketsInitialized'] = true;
        }
    }

    public _webSocketsInitialized(fnc: () => void): void {
        this._callbacks['webSocketsInitialized'] = fnc;

        if (this._callbacks['_webSocketsInitialized'] != null) {
            this.log(`G2P - webSocketsInitialized`);
            fnc();
            this._callbacks['_webSocketsInitialized'] = null;
        }
    }

    public iconsCountAvailable(count: number): void {
        if (this._callbacks['iconsCountAvailable'] != null) {
            this.log(`G2P - iconsCountAvailable - ${count}`);
            const fn = this._callbacks['iconsCountAvailable'];
            fn(count);
        } else if (!this._started) {
            this._callbacks['_iconsCountAvailable'] = count;
        }
    }

    public _iconsCountAvailable(fnc: (count: number) => void): void {
        this._callbacks['iconsCountAvailable'] = fnc;

        if (this._callbacks['_iconsCountAvailable'] != null) {
            this.log(`G2P - iconsCountAvailable - ${this._callbacks['_iconsCountAvailable']}`);
            fnc(this._callbacks['_iconsCountAvailable']);
            this._callbacks['_iconsCountAvailable'] = null;
        }
    }

    protected asyncTask(fnc: () => Promise<void>): void {
        if (fnc != null) {
            BasePlugin.AsyncTasks.push(fnc);
        }

        BasePlugin.runAsyncTasks();
    }

    public static runAsyncTasks(finished: boolean = false): void {
        if (BasePlugin.AsyncRunning) {
            return;
        }

        if (BasePlugin.AsyncTasks.length === 0) {
            if (finished) {
                Platforms.roundInit();
            }
            return;
        }

        let fnc = BasePlugin.AsyncTasks.shift();
        if (fnc != null) {
            BasePlugin.AsyncRunning = true;
            fnc().then(value => {
                BasePlugin.AsyncRunning = false;
                BasePlugin.runAsyncTasks(true);
            })
        }
    }

    //******************************************************************************************************************
    //  INIT
    //******************************************************************************************************************

    public init(): void {
        if (!this.validateUrl(this._pluginUrl)) {
            this.log(`PluginUrl - ${this._pluginUrl} is not valid`);
            return;
        }

        let script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', UriHelper.setTimeStamp(this._pluginUrl, Preloader.getVersionId()));
        script.setAttribute('type', 'module');
        script.onload = this.onPluginLoaded.bind(this, this._instanceName);
        document.head.appendChild(script);

        this.log(`Loading plugin started`);
    }

    protected onPluginLoaded(instanceName: string): void {
        if (window[instanceName] === null) {
            this.log(`Instance - ${instanceName} was not found`);
            return;
        }

        const instance = window[instanceName] as IPlugin;
        instance.init(this._clientHub, this._clientEvents);
        this.log(`Plugin loaded, call init`);

        if (this._callStart && !this._started) {
            this.gameStarted(this._startData);
        }

        if (this._idle) {
            //if the game is in idle state, call roundInit,
            //because roundInit was called before the plugin was loaded
            this.roundInit().then(value => {});
        }
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    protected validateUrl(url: string): boolean {
        try {
            const uri = new URL(url);
            return true;
        } catch (e) {
            if (DEBUG) {
                Logger.debugGroup('Platforms', "Provided url for getting origin is not valid, returning '*'.");
            }
        }

        return false;
    }

    //******************************************************************************************************************
    //  LOGGER
    //******************************************************************************************************************

    protected log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup('BasePlugin', 'BasePlugin ' + s);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Plugins/PlayerRetention/Plugins/BasePlugin.ts
 **/